// extracted by mini-css-extract-plugin
export default {"guarantor":"Guarantor_guarantor__7EYwX"};